import { c as _c } from "react/compiler-runtime";
import { ReactElement, memo } from 'react';
import ImageComponent from '@spa/components/image-component/image.component';
export interface Props {
  readonly filledStars: number;
  readonly hasHalfStar?: boolean;
  readonly maxStars?: number;
  readonly starClassName?: string;
}
const DEFAULT_MAX_STARS = 5;
function BazaarvoiceReviewStarsComponent(t0) {
  const $ = _c(9);
  const {
    filledStars,
    hasHalfStar: t1,
    maxStars: t2,
    starClassName
  } = t0;
  const hasHalfStar = t1 === undefined ? false : t1;
  const maxStars = t2 === undefined ? DEFAULT_MAX_STARS : t2;
  let t3;
  if ($[0] !== filledStars || $[1] !== hasHalfStar || $[2] !== maxStars || $[3] !== starClassName) {
    let t4;
    if ($[5] !== filledStars || $[6] !== hasHalfStar || $[7] !== starClassName) {
      t4 = (_, index) => {
        const star = index + 1;
        let iconKey = "star-rating-empty";
        if (star <= filledStars) {
          iconKey = "star-rating-full";
        } else {
          if (hasHalfStar && star === filledStars + 1) {
            iconKey = "star-rating-half";
          }
        }
        return <ImageComponent key={star} src={`/assets/icons/${iconKey}.svg`} height={16} width={16} alt="" className={starClassName} />;
      };
      $[5] = filledStars;
      $[6] = hasHalfStar;
      $[7] = starClassName;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = <>{Array.from({
        length: maxStars
      }, t4)}</>;
    $[0] = filledStars;
    $[1] = hasHalfStar;
    $[2] = maxStars;
    $[3] = starClassName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export default memo(BazaarvoiceReviewStarsComponent);